import { useNavigate } from "react-router-dom";
import { portalLogout } from "@/features/portal/api";
import { portalSignInHref } from "@/features/portal/portal-base";
import { usePortalSessionStore } from "@/features/portal/store/portal-session-store";

/**
 * Shared portal sign-out: best-effort server logout, clear the local session,
 * then land on the firm's branded sign-in (or the generic portal root when the
 * handle is unknown). Used by the portal nav header and the home hub so there's
 * one implementation.
 */
export function usePortalLogout() {
  const navigate = useNavigate();
  const branding = usePortalSessionStore((s) => s.branding);

  return async function logout() {
    try {
      await portalLogout();
    } catch {
      /* log out locally regardless of the network result */
    }
    // Resolve the handle before clearing (`portalName` survives clearSession,
    // but read it up front and keep the branding fallback for older sessions).
    const handle = usePortalSessionStore.getState().portalName ?? branding?.portalName;
    usePortalSessionStore.getState().clearSession();
    navigate(portalSignInHref(handle));
  };
}
